//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapMutations } from "vuex";
import { debounce } from "quasar";
import UsersGroupsContent from "./users-groups-content.vue";

export default {
    name: "UsersGroupsTabs",
    components: {
        UsersGroupsContent
    },
    data() {
        return {
            selectedTab: "tab-users",
            filter: "",
            clicked: false,
            dataUsers: [],
            dataGroups: [],
            itemsListUsers: [],
            itemsListGroups: [],
            itemsSearchUsers: 0,
            itemsSearchGroups: 0,
            totalUsers: 0,
            totalGroups: 0,
            tabGroupActive: false,
            itemsPayload: {
                pageSize: 20,
                pageNumber: 0,
                types: [],
                statuses: [],
                searchValue: ""
            },
            activeTab: "users",
            skeletonState: true,
            loadMoreContent: false,
            loadQuery: {},
            loadWithoutQuery: false,
            updateList: false
        };
    },
    computed: {
        ...mapGetters("admin", ["getPaginatedGroupList", "getPaginatedUsersList"]),
        ...mapGetters("apps", ["apps"]),
        getUsersTabProps() {
            return {
                currentItemsList: this.itemsListUsers,
                totalNumberItems: this.totalUsers,
                skeletonState: this.skeletonState
            };
        },
        getGroupsTabProps() {
            return {
                type: "GROUPS",
                currentItemsList: this.itemsListGroups,
                totalNumberItems: this.totalGroups,
                skeletonState: this.skeletonState
            };
        }
    },
    watch: {
        getPaginatedUsersList: {
            handler(newValue) {
                this.itemsListUsers = newValue ? [...newValue] : [];
            },
            immediate: true
        },
        getPaginatedGroupList: {
            handler(newValue) {
                this.itemsListGroups = newValue ? [...newValue] : [];
                this.setGroupApplicationName();
            },
            immediate: true
        },
        apps: {
            handler() {
                this.setGroupApplicationName();
            },
            immediate: true
        },
        "$route.query.tab": {
            handler(newValue) {
                if (newValue) {
                    this.activeTab = newValue;
                    this.selectedTab = `tab-${newValue}`;
                }
            }
        }
    },
    created() {
        const { query } = this.$route;
        if (query && !Object.keys(query).length) {
            this.loadWithoutQuery = true;
        }
        if (!this.apps || !this.apps.length) {
            this.getAllApps();
        }
        if (query && query.tab === "groups") {
            this.getGroups();
        } else {
            this.getUsers();
        }
        this.getMultiFeaturesOption().then(data => {
            const accessibilityObj = data.data.find(item => item.code === "ACCESSIBILITY");
            this.$store.commit("main/setShowAccessibilityOption", accessibilityObj.enabled);
        });
    },
    mounted() {
        this.loadQueryFromUrl();
    },
    activated() {
        const { query } = this.$route;
        if (query && !Object.keys(query).length) {
            this.loadWithoutQuery = true;
        }
        this.loadQueryFromUrl();
    },
    deactivated() {
        this.selectedTab = "tab-users";
    },
    methods: {
        ...mapActions("admin", ["getRoleList", "getUsersList"]),
        ...mapActions("main", ["getMultiFeaturesOption"]),
        ...mapActions("apps", ["getAllApps"]),
        ...mapMutations("admin", ["setRoleList", "setUserList", "setPaginatedGroupsList", "setPaginatedUsersList"]),
        ...mapMutations("main", ["setShowAccessibilityOption"]),
        setGroupApplicationName() {
            if (this.itemsListGroups && this.itemsListGroups.length && this.apps && this.apps.length) {
                this.itemsListGroups.forEach(element => {
                    const app = this.apps.find(elem => elem.id === element.applicationId);
                    element.application = app ? app.name : "";
                });
            }
        },
        changeTabState(type) {
            this.activeTab = type;
            this.$router.replace({ query: { tab: type } });
        },
        getUsers: debounce(function (payload) {
            if (this.loadWithoutQuery || this.activeTab === "users") {
                this.skeletonState = !this.loadMoreContent;
                this.loadMoreContent = false;
                if (payload && payload.pageSize <= 10) {
                    payload.addItems = true;
                }
                this.applyQueryOnLoad("users", payload);
                if (payload && payload.statuses && payload.statuses.length === 3) {
                    payload.statuses = [];
                }
                this.getUsersList(payload || { ...this.itemsPayload }).then(
                    (data) => {
                        this.skeletonState = false;
                        this.setPaginatedUsersList({ data: data.data.list, addItems: payload && payload.addItems });
                        this.totalUsers = data.data.totalCount;
                        this.itemsSearchUsers = (payload && payload.searchValue) ? this.totalUsers : 0;
                    }
                );
            }
            this.loadWithoutQuery = false;
        }, 600),
        getGroups: debounce(function (payload) {
            if (this.loadWithoutQuery || this.activeTab === "groups") {
                this.skeletonState = !this.loadMoreContent;
                this.loadMoreContent = false;
                if (payload && payload.pageSize <= 10) {
                    payload.addItems = true;
                }
                this.applyQueryOnLoad("groups", payload);
                this.getRoleList(payload || { ...this.itemsPayload }).then(
                    (data) => {
                        this.skeletonState = false;
                        this.setPaginatedGroupsList({ data: data.data.list, addItems: payload && payload.addItems });
                        this.totalGroups = data.data.totalCount;
                        this.itemsSearchGroups = (payload && payload.searchValue) ? this.totalGroups : 0;
                    }
                );
            }
            this.loadWithoutQuery = false;
        }, 600),
        applyQueryOnLoad(tab, queryToLoad) {
            const { query } = this.$route;
            const objForQuery = {};
            if (query && query.tab === tab) {
                if (queryToLoad) {
                    [, queryToLoad.tab] = this.selectedTab.split("-");
                    const orderedKeys = ["tab", "searchValue", "types", "statuses"];

                    orderedKeys.forEach((key) => {
                        if (queryToLoad.hasOwnProperty(key)) {
                            const value = queryToLoad[key];
                            if (Array.isArray(value) && value.length > 0) {
                                objForQuery[key] = value.join(",");
                            } else if (!Array.isArray(value) && value !== "" && value !== null && typeof value !== "number") {
                                objForQuery[key] = value;
                            }
                        }
                    });

                    Object.entries(queryToLoad).forEach(([key, value]) => {
                        if (Array.isArray(value) && value.length > 0) {
                            this.itemsPayload[key] = value;
                        } else if (!Array.isArray(value) && value !== "" && value !== null && typeof value !== "number") {
                            this.itemsPayload[key] = value;
                        }
                    });

                    if (!this.deepEqual(objForQuery, this.$route.query)) {
                        if (this.dropdownIsOpen) {
                            this.updateList = true;
                        }
                        this.$router.replace({ query: objForQuery });
                    }
                } else {
                    if (query.searchValue) {
                        this.itemsPayload.searchValue = query.searchValue;
                    }
                    ["types", "statuses"].forEach(key => {
                        if (query[key]) {
                            this.itemsPayload[key] = query[key].split(",");
                        }
                    });
                }
            }
        },
        loadQueryFromUrl() {
            const { query } = this.$route;
            if (query && Object.keys(query).length) {
                this.activeTab = query.tab;
                this.selectedTab = `tab-${query.tab}`;
                this.loadQuery = { ...query };
            }
        },
        deepEqual(obj1, obj2) {
            if (obj1 === obj2) return true;
            if (obj1 && typeof obj1 === "object" && obj2 && typeof obj2 === "object") {
                const keys1 = Object.keys(obj1);
                const keys2 = Object.keys(obj2);
                return keys1.length === keys2.length && keys1.every(key => this.deepEqual(obj1[key], obj2[key]));
            }
            return false;
        },
        checkIfDropdownOpened(data) {
            this.dropdownIsOpen = data;
        }
    }
};
